<template>
  <div class="d-breadcrumb breadcrumb">
    <ul
      v-if="breadcrumbs.length > 1 || alwaysShow"
      class="is-hidden-mobile"
    >
      <li
        v-for="(breadcrumb, index) in breadcrumbs"
        :key="index"
      >
        <router-link
          :to="getPath(breadcrumb)"
        >
          <span v-if="breadcrumb.meta.breadcrumb.icon">
            <i
              class="mdi"
              :class="breadcrumb.meta.breadcrumb.icon"
            />
          </span>
          <span v-else>
            {{ getBreadcrumb(breadcrumb) }}
          </span>
        </router-link>
      </li>
    </ul>
    <ul
      v-if="mobileBreadcrumb"
      class="is-hidden-tablet"
    >
      <li>
        <router-link :to="getPath(mobileBreadcrumb)">
          <span v-if="mobileBreadcrumb.meta.breadcrumb.icon">
            <i
              class="mdi"
              :class="mobileBreadcrumb.meta.breadcrumb.icon"
            />
          </span>
          <span v-else>
            <i
              class="mdi pr-2 mdi-arrow-left"
            />{{ getBreadcrumb(mobileBreadcrumb) }}</span>
        </router-link>
      </li>
    </ul>
    <ul
      v-else-if="alwaysShow"
      class="is-hidden-tablet"
    >
      <li>
        <i class="mdi pr-2 mdi-home" />
        <span>{{ $t('home') }}</span>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: {
    alwaysShow: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    mobileBreadcrumb() {

      for (let i = this.breadcrumbs.length - 1; i >= 0; i--) {
        if (this.breadcrumbs[i].path && this.breadcrumbs[i].name != this.$route.name) {
          return this.breadcrumbs[i];
        }
      }

      return null;
    },
    breadcrumbs() {
      function findParents(routeName, matches = []) {

        const routeParents = this.$router.resolve({ name: routeName }).route.matched;
        const routeParent = routeParents[routeParents.length - 1];
        matches.unshift(routeParent);

        const parentName = routeParent.meta?.breadcrumb?.parent;

        if (parentName) {
          return findParents.call(this, routeParent.meta.breadcrumb.parent, matches);
        }

        return matches;
      }

      let matchedRoute = this.$route.matched.filter(r => r.meta?.breadcrumb != null);

      if (matchedRoute.length > 0) {
        matchedRoute = [matchedRoute[matchedRoute.length - 1]];
      }

      return matchedRoute
        .flatMap((route) => {
          let routeRecord = [route];
          let breadcrumb = route.meta?.breadcrumb;

          if (typeof breadcrumb === "function") {
            breadcrumb = breadcrumb.call(this, this.$route.params);
          }

          if (breadcrumb?.parent) {
            const matched = findParents.call(this, breadcrumb.parent, []);
            routeRecord = [...matched, ...routeRecord];
          }

          return routeRecord;
        })
        .map((route) => route.path.length === 0
          ? ({ ...route, path: "/" })
          : route
        )
        .filter(route => route.meta && route.meta.breadcrumb);
    }
  },
  methods: {
    getPath(breadcrumb) {
      let { path } = breadcrumb;

      for (const [key, value] of Object.entries(this.$route.params)) {
        path = path.replace(`:${key}`, value);
      }

      return path;
    },
    getBreadcrumb(breadcrumb) {

      let crumb = breadcrumb.meta.breadcrumb;

      if (_.isObject(crumb)) {

        if (crumb.label) {
          return crumb.label;
        }

        if (crumb.meta) {
          if (this.$metadata[crumb.meta]) {
            return this.$metadata[crumb.meta];
          }
        }
      }

      return null;
    }
  }
};
</script>
